import { cn } from "@spz/ui/lib/utils";
import { StatusTag } from "../../status-tag";
import type { StatusCellProps } from "../types";

export const StatusCell: React.FC<StatusCellProps> = ({
  value,
  label,
  className,
}) => {
  return (
    <span className={cn("w-10", className)}>
      <StatusTag status={value ?? "not_started"} label={label} />
    </span>
  );
};
